import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const MobileContentManagerWrapper = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.graySecondary};
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
`;
